/**
 * Group Outreach module constants.
 * Shared, isolated values for the two-step group outreach flow (viewer + editor).
 */

/** Flow steps. */
export const STEP = {
  VIEWER: 'viewer',
  EDITOR: 'editor',
};

/** Email-availability filter pills shown above the creator list. */
export const FILTER_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'withEmail', label: 'With Email' },
  { key: 'withoutEmail', label: 'Without Email' },
];

/** Default sender payload when no connected mailbox is selected. */
export const DEFAULT_SENDER_INFO = { platform: 'default', oauthInfoId: null };

/** Froala toolbar for the group email body (kept intentionally minimal). */
export const GROUP_OUTREACH_TOOLBAR = ['fontSize', 'bold', 'italic', 'insertLink'];

/** Copy for the dismissible personalization hint in the editor. */
export const PERSONALIZATION_TIP = {
  title: 'Personalization variable',
  // `{name}` is replaced with the recipient's first name server-side.
  body: "You can use {name} in your message. It will be replaced with the recipient's first name.",
};
